export const IS_LOADING_REDUX_STATE = 'isLoading';
export const PROJECT_NAME = 'HELP_TO_TRAVEL__';

export const USER_IS_LOGGED = 'USER_IS_LOGGED';

export const HILFESUCHENDER = 'HILFESUCHENDER';
export const HILFEGEBENDER = 'HILFEGEBENDER';
